import { Text, Center, Alert, AlertIcon, AlertTitle, AlertDescription, Flex } from '@chakra-ui/react';
import { useTranslation } from 'helpers/languages/translations';
import { useNavigate } from 'react-router';
import { linkStyle } from 'shared/styles';
import { TAliasProps } from '../AliasContainer';
import { emptyAlertStyle } from '../styles';

const AliasEmpty = ({ onOpenAdd, readonly }: TAliasProps) => {
    const translate = useTranslation();
    const navigate = useNavigate();

    return (
        <Center height="400px">
            <Alert status="info" {...emptyAlertStyle}>
                <AlertIcon boxSize="40px" mr={0} />
                <AlertTitle mt={4} mb={1} fontSize="lg">
                    {translate('alias.empty')}
                </AlertTitle>
                {!readonly && (
                    <AlertDescription maxWidth="sm">
                        <Flex>
                            <Text>
                                {translate('alias.empty.description', {
                                    uploadBtn: (
                                        <Text onClick={() => navigate('upload')} as="span" {...linkStyle}>
                                            {translate('alias.empty.uploadFile')}
                                        </Text>
                                    ),
                                    manualAddBtn: (
                                        <Text onClick={onOpenAdd} as="span" {...linkStyle}>
                                            {translate('alias.empty.manualAdd')}
                                        </Text>
                                    ),
                                })}
                            </Text>
                        </Flex>
                    </AlertDescription>
                )}
            </Alert>
        </Center>
    );
};

export default AliasEmpty;
